module.exports = __webpack_public_path__ + "img/2_236.06746e8f.png";